import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import { enhanceResizeObserver } from "@/utils/resizeObserverEnhancer";
import { createPinia } from "pinia";

enhanceResizeObserver(); // 调用增强逻辑
// 创建 Vue 应用实例
const app = createApp(App);
const pinia = createPinia();

// 使用插件
app.use(router); // 如果有 Vue Router
app.use(ElementPlus); // 注册 Element Plus
app.use(pinia); // 注册 Pinia
// 挂载应用到 DOM
app.mount("#app");
